import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useCreateMasterDataMapping } from "@/hooks/use-master-data-mappings";
import type { MasterDataEntityType } from "@/lib/enums";
import { MasterDataMappingForm } from "./MasterDataMappingForm";

interface MasterDataMappingCreateDialogProps {
  entityType: MasterDataEntityType;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Create dialog — wraps the shared `MasterDataMappingForm`. Triggered from the table toolbar. */
export function MasterDataMappingCreateDialog({
  entityType,
  open,
  onOpenChange,
}: MasterDataMappingCreateDialogProps) {
  const createMapping = useCreateMasterDataMapping();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New mapping</DialogTitle>
          <DialogDescription>
            Resolve a master-data reference from one BU to its equivalent in another.
          </DialogDescription>
        </DialogHeader>
        <MasterDataMappingForm
          entityType={entityType}
          submitLabel="Create"
          isSaving={createMapping.isPending}
          onCancel={() => onOpenChange(false)}
          onSubmit={(values) =>
            createMapping.mutate(values, { onSuccess: () => onOpenChange(false) })
          }
        />
      </DialogContent>
    </Dialog>
  );
}
